<template>
  <div class="p-list-representation-province-item  d-flex flex-grow-1 col-lg-10 ">
            <div class="d-flex w-100 p-list-representation-data flex-column flex-lg-row">
                <div class="w-100 d-flex flex-wrap align-items-center col-lg-4">
                    <h3 class="col-lg-2 p-list-representation-province-item-title mb-lg-0 mb-3  ">استان</h3>

                      <multiselect
                       v-model="valueProvince"
                       :options="provinceItems"
                       placeholder="لطفا استان خود را انتخاب کنید"
                       label="name"
                       track-by="name"
                       :show-labels="false"
                       :allow-empty="false"
                       class="col-lg-9"
                       >
                       </multiselect>
                  </CDropdown>
                </div>


                <div class="w-100 d-flex flex-wrap align-items-center col-lg-4 mt-4 mb-4 mt-lg-0 mb-lg-0" :key="updateCitySelected">
                    <h3 class="col-lg-2 p-list-representation-province-item-title  mb-lg-0 mb-3  ">شهر</h3>

                      <multiselect
                       v-model="valueCity"
                       :options="citys"
                       placeholder="لطفا شهر خود را انتخاب کنید"
                       label="name"
                       track-by="name"
                       :show-labels="false"
                       :allow-empty="false"
                       class="col-lg-9"

                       >
                       </multiselect>
                  </CDropdown>
                </div>

        </div>
  </div>
</template>

<script>


export default {
  name: "cityAndProvince",
  components: {
  },

  props: {
    citys                : {type:Array,default:[]},
    provinceItems        : {type:Array,default:[]},
    citySelected         : {type:Object,default:{}},
    provinceSelected     : {type:Object,default:{}},
    updateCitySelected   : {type:Number,default:0},

  },

  data() {
    return {
      selectedCity       : 'لطفا شهر خود را انتخاب کنید',
      selectedProvince   : 'لطفا استان خود را انتخاب کنید',
      valueCity          : {},
      valueProvince      : {},

    }
  },

  watch: {
    valueCity(data){
      this.$emit('selectedCity',data);
    },

    valueProvince(data){
      this.$emit('selectedProvince',data);
    },

    citySelected(data){
      this.valueCity = data;
    },

    provinceSelected(data){
      this.valueProvince = data;
    },


  },

  created() {

  },

  mounted() {
    this.defaultSelecteBox();
  },

  methods: {
    changeCity(data){
      this.valueCity.status = 'run'
    },

    changeProvinceItems(data){
    },

    defaultSelecteBox(){

      if (typeof(this.citySelected.id) != 'undefined') {
        this.valueCity  = this.citySelected;
      }

      if (typeof(this.provinceSelected.id) != 'undefined') {
        this.valueProvince  = this.provinceSelected;
      }

    }

  }


}
</script>
